// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__38Ili","image":"NotFound_image__38KBP","title":"NotFound_title__3STP6"};